import Table from "@/utils/Table";
export default function specSum( rowOfValues) {
    return [
        Table.checkValueWithNullAndReturnND(rowOfValues.data.npsfo22, 0, 'integer'),
        Table.checkValueWithNullAndReturnND(rowOfValues.data.npsro22, 0, 'integer'),
        Table.checkValueWithNullAndReturnND(rowOfValues.data.npsmo22, 0, 'integer'),
        Table.checkValueWithNullAndReturnND(rowOfValues.data.npspo22, 0, 'integer'),
    ].reduce((prev, cur) => {
        if (cur !== 'NA')
            prev +=cur;
        return prev;
    })
}